import React, { useState, useEffect, useMemo } from 'react';
import styles from './ViewFeedbackDetails.module.css';
import { useTranslation } from 'react-i18next';
import Card from 'react-bootstrap/Card';
import { CardHeader } from 'react-bootstrap';
import DatatTable from '../../basic-component/TableNoStyle';
// import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid,
} from '@mui/material';
import { generateAppropriateDate } from '../../basic-component/DateUtils';

const ReceiptDetails = ({ data }) => {
  const { t } = useTranslation();
  const columnData = useMemo(
    () => [

      {
        accessorKey: 'Receiver',
        header: t('feedbackDetails.receiver.text'),
        size: 20,
      },
      {
        accessorKey: 'MasterArea',
        header: t('report.page.aging.table.header.area'),
        size: 40,

      },
      {
        accessorKey: 'SubArea',
        header: t('report.page.aging.table.header.subarea'),
        size: 30,
      },
      {
        accessorKey: 'TargetDate',
        header: t('feedbackDetails.targetCompilationDate.text'),
        size: 40,
        enableSorting: false,
      },
      {
        accessorKey: 'Actual_Closing_Date',
        header: t('feedbackDetails.actualCloseDate.text'),
        size: 40,
        enableSorting: false,
      },
      {
        accessorKey: 'Assigned_To',
        header: t('feedbackDetails.assignedTo.text'),
        size: 50,
        enableSorting: false,
      },
      // {
      //   accessorKey: 'status',
      //   header: t('label.new.survey.status'),
      //   size: 40,
      //   enableSorting: false,
      // },
    ],
    [t],
  );
  const [jsonData, setJsonData] = useState(null);

  useEffect(() => {
    if (typeof data === 'object') {
      setJsonData(data);
    } else if (typeof data === 'string') {
      try {
        const parsedData = JSON.parse(data);
        setJsonData(parsedData);
      } catch (error) {
        console.error('Error parsing JSON data', error);
      }
    }
  }, [data]);
  const tableStyles = {
    width: " 100%",
    height: "auto",
    minWidth: "0"
  }
  const rowsData = [];
  if (jsonData && jsonData.receiptDetails && jsonData.receiptDetails.length > 0) {
    const receiptDetails = jsonData.receiptDetails.map((item, index) => {
      rowsData.push({
        Receiver: item.user.firstName + " " + item.user.lastName,
        MasterArea: item.area.description,
        SubArea: item.subArea.description,
        TargetDate: generateAppropriateDate(item.targetTime),
        Actual_Closing_Date: generateAppropriateDate(item.cmltnDate),
        Assigned_To: item.assigneeGroup.assigneName || 'N/A',
        // status: item.status,
      });
    });
  }



  // const { t } = useTranslation();
 

  if (jsonData && jsonData.receiptDetails && jsonData.receiptDetails.length > 0) {
    const receiptDetails = jsonData.receiptDetails.map((item, index) => (
      <TableRow key={index}>
        <TableCell>{item.user.firstName} {item.user.lastName}</TableCell>
        <TableCell>{item.area.description}</TableCell>
        <TableCell>{item.subArea.description}</TableCell>
        <TableCell>{generateAppropriateDate(item.targetTime)}</TableCell>
        <TableCell>{generateAppropriateDate(item.cmltnDate)}</TableCell>
        <TableCell>{item.assigneeGroup.assigneName || 'N/A'}</TableCell>
      </TableRow>
    ));

    return (
      //     <Grid container spacing={3}>
      //       <Grid item xs={12}>
      //         {/* <Typography variant="h5">Receipt Details</Typography> */}
      //         <TableContainer component={Paper}>
      //           <Table>
      //             <TableHead sx={{
      //               height:"0rem",
      //               maxHeight:'2rem',
      //               minHeight:"0.5rem"

      //             }}>
      //               <TableRow style={{ backgroundColor: '#867FA1' , height: '1vh'  }}>
      //                 <TableCell className={styles.tableHeight}>{t('feedbackDetails.receiver.text')}</TableCell>
      //                 <TableCell className={styles.tableHeight}>{t('menu.key.master.area')}</TableCell>
      //                 <TableCell className={styles.tableHeight}>{t('menu.key.sub.area')}</TableCell>
      //                 <TableCell className={styles.tableHeight}>Target Date</TableCell>
      //                 <TableCell className={styles.tableHeight}>{t('feedbackDetails.actualCloseDate.text')}</TableCell>
      //                 <TableCell className={styles.tableHeight}>{t('feedbackDetails.assignedTo.text')}</TableCell>
      //               </TableRow>
      //             </TableHead>
      //             <TableBody>{receiptDetails}</TableBody>
      //           </Table>
      //         </TableContainer>
      //       </Grid>
      //     </Grid>
      //   );
      // } else {
      //   return <Typography variant="body1">{t('general.label.no.data.available')}</Typography>;
      // }
      <Card className='overflow-hidden'>
        <DatatTable tableStyles={tableStyles} tableData={{ columnData: columnData, rowsData: rowsData }} />
      </Card>
    );
  };
};

export default ReceiptDetails;
